(function () {
  'use strict';

  var DEBOUNCE_MS = 300;
  var applyCounter = 0;

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function getMainForm(panel) {
    return panel ? panel.querySelector('#collection-filters-form') : null;
  }

  function getJsForm(panel) {
    if (!panel) return null;
    return panel.querySelector('.group-type-list-wrapper .collection-filters_form');
  }

  function getPriceWrap(root) {
    if (!root) return null;
    if (root.classList && root.classList.contains('range-slider')) return root;
    return root.querySelector('.main-range-slider, .range-slider');
  }

  function isAjaxActive(panel) {
    return !!(panel && panel.classList.contains('active-ajax'));
  }

  function getActiveForm(panel) {
    if (!panel) return null;
    return isAjaxActive(panel) ? getJsForm(panel) : getMainForm(panel);
  }

  function activatePriceRange(track) {
    if (track) track.removeAttribute('data-price-default');
  }

  function updateRangeFill(track, ranges) {
    if (!track || !ranges || ranges.length < 2) return;

    var min = parseFloat(ranges[0].value);
    var max = parseFloat(ranges[1].value);
    var floor = parseFloat(ranges[0].min) || 0;
    var ceiling = parseFloat(ranges[0].max) || 100;
    if (isNaN(min)) min = floor;
    if (isNaN(max)) max = ceiling;
    if (min < floor) min = floor;
    if (max > ceiling) max = ceiling;
    if (min > max) max = min;

    var span = ceiling - floor || 1;
    var minPct = ((min - floor) / span) * 100;
    var maxPct = ((max - floor) / span) * 100;
    track.style.setProperty('--price-range-min', minPct + '%');
    track.style.setProperty('--price-range-max', maxPct + '%');
  }

  function getThumbClientX(rangeInput, value) {
    var rect = rangeInput.getBoundingClientRect();
    var floor = parseFloat(rangeInput.min) || 0;
    var ceiling = parseFloat(rangeInput.max) || 100;
    var val = value !== undefined && value !== null ? parseFloat(value) : parseFloat(rangeInput.value);
    if (isNaN(val)) val = floor;
    var span = ceiling - floor || 1;
    return rect.left + ((val - floor) / span) * rect.width;
  }

  function valueFromPointer(clientX, rangeInput) {
    var rect = rangeInput.getBoundingClientRect();
    if (!rect.width) return parseFloat(rangeInput.min) || 0;
    var floor = parseFloat(rangeInput.min) || 0;
    var ceiling = parseFloat(rangeInput.max) || 100;
    var step = parseFloat(rangeInput.step) || 1;
    var pct = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
    var raw = floor + pct * (ceiling - floor);
    var stepped = Math.round(raw / step) * step;
    return Math.min(ceiling, Math.max(floor, stepped));
  }

  var activeRangeDrag = null;

  function endActiveRangeDrag() {
    if (!activeRangeDrag) return;
    document.removeEventListener('pointermove', activeRangeDrag.move);
    document.removeEventListener('pointerup', activeRangeDrag.end);
    document.removeEventListener('pointercancel', activeRangeDrag.end);
    activeRangeDrag = null;
  }

  function resolveRangeThumb(minRange, maxRange, clientX) {
    var minPos = getThumbClientX(minRange);
    var maxPos = getThumbClientX(maxRange);
    var distMin = Math.abs(clientX - minPos);
    var distMax = Math.abs(clientX - maxPos);
    if (distMin === distMax) {
      return clientX <= (minPos + maxPos) / 2 ? 'min' : 'max';
    }
    return distMin < distMax ? 'min' : 'max';
  }

  function setRangeValue(panel, rangeInput, minRange, maxRange, clientX) {
    var value = valueFromPointer(clientX, rangeInput);
    if (rangeInput === minRange) {
      minRange.value = Math.min(value, parseFloat(maxRange.value));
    } else {
      maxRange.value = Math.max(value, parseFloat(minRange.value));
    }
    handleRangeSliderInput(panel, rangeInput);
  }

  function beginRangeDrag(panel, rangeInput, minRange, maxRange) {
    endActiveRangeDrag();

    var move = function (e) {
      setRangeValue(panel, rangeInput, minRange, maxRange, e.clientX);
    };

    var end = function () {
      endActiveRangeDrag();
    };

    activeRangeDrag = { move: move, end: end };
    document.addEventListener('pointermove', move);
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);
  }

  function bindPriceRangeTrack(panel, track) {
    if (!track || track.dataset.rangeBound === 'true') return;
    track.dataset.rangeBound = 'true';

    var parent = track.closest('.range-slider');
    if (!parent) return;

    var minRange = parent.querySelector('.input-price-range__input--min');
    var maxRange = parent.querySelector('.input-price-range__input--max');
    if (!minRange || !maxRange) return;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      var active = resolveRangeThumb(minRange, maxRange, event.clientX);
      var rangeInput = active === 'min' ? minRange : maxRange;

      event.preventDefault();
      setRangeValue(panel, rangeInput, minRange, maxRange, event.clientX);
      beginRangeDrag(panel, rangeInput, minRange, maxRange);
    });
  }

  function bindPriceRangeTracks(panel, root) {
    endActiveRangeDrag();
    (root || panel).querySelectorAll('.input-price-range').forEach(function (track) {
      bindPriceRangeTrack(panel, track);
    });
  }

  function initRangeFills(root) {
    (root || document).querySelectorAll('.input-price-range').forEach(function (track) {
      var ranges = track.querySelectorAll('input[type="range"]');
      if (ranges.length >= 2) updateRangeFill(track, ranges);
    });
  }

  function clearQuickRanges(scope) {
    if (!scope) return;
    scope.querySelectorAll('.js-filter-price-quick:checked').forEach(function (radio) {
      radio.checked = false;
    });
  }

  function syncPriceWrapToMain(panel, sourceWrap) {
    var mainWrap = getPriceWrap(getMainForm(panel));
    if (!mainWrap || !sourceWrap || mainWrap === sourceWrap) return;

    ['min', 'max'].forEach(function (key) {
      var cls = key === 'min' ? '.field__input-min' : '.field__input-max';
      var mainInput = mainWrap.querySelector(cls);
      var sourceInput = sourceWrap.querySelector(cls);
      if (mainInput && sourceInput) mainInput.value = sourceInput.value;
    });

    var mainRanges = mainWrap.querySelectorAll('input[type="range"]');
    var sourceRanges = sourceWrap.querySelectorAll('input[type="range"]');
    if (mainRanges.length >= 2 && sourceRanges.length >= 2) {
      mainRanges[0].value = sourceRanges[0].value;
      mainRanges[1].value = sourceRanges[1].value;
    }

    var mainTrack = mainWrap.querySelector('.input-price-range');
    var sourceTrack = sourceWrap.querySelector('.input-price-range');
    if (mainTrack && sourceTrack) {
      if (sourceTrack.getAttribute('data-price-default') === 'true') {
        mainTrack.setAttribute('data-price-default', 'true');
      } else {
        mainTrack.removeAttribute('data-price-default');
      }
      updateRangeFill(mainTrack, mainRanges);
    }
  }

  function buildFilterQuery(form) {
    if (!form) return '';

    var params = new URLSearchParams();
    form.querySelectorAll('.filter-group-display__list-item_checkbox:checked').forEach(function (cb) {
      if (cb.name && cb.value !== '') {
        params.append(cb.name, cb.value);
      }
    });

    var priceWrap = getPriceWrap(form);
    if (priceWrap) {
      var min = priceWrap.querySelector('.field__input-min');
      var max = priceWrap.querySelector('.field__input-max');
      var track = priceWrap.querySelector('.input-price-range');
      var isDefault = track && track.getAttribute('data-price-default') === 'true';

      if (!isDefault) {
        if (min && min.name && min.value !== '') params.append(min.name, min.value);
        if (max && max.name && max.value !== '') params.append(max.name, max.value);
      }
    }

    return params.toString();
  }

  function getFilterQuery(panel) {
    var preferredForm = panel && panel._preferredFilterForm;
    syncActiveFormToMain(panel, preferredForm);
    var form = preferredForm || getActiveForm(panel) || getMainForm(panel);
    return buildFilterQuery(form);
  }

  function syncFormToTarget(sourceForm, targetForm) {
    if (!sourceForm || !targetForm || sourceForm === targetForm) return;

    targetForm.querySelectorAll('.filter-group-display__list-item_checkbox').forEach(function (cb) {
      cb.checked = false;
    });

    sourceForm.querySelectorAll('.filter-group-display__list-item_checkbox:checked').forEach(function (activeCb) {
      if (!activeCb.name) return;
      targetForm.querySelectorAll('.filter-group-display__list-item_checkbox[name="' + activeCb.name + '"]').forEach(function (targetCb) {
        if (targetCb.value === activeCb.value) {
          targetCb.checked = true;
          return;
        }
        try {
          if (decodeURIComponent(targetCb.value) === activeCb.value) targetCb.checked = true;
        } catch (e) {
          /* ignore */
        }
        try {
          if (targetCb.value === decodeURIComponent(activeCb.value)) targetCb.checked = true;
        } catch (e) {
          /* ignore */
        }
      });
    });

    var sourceWrap = getPriceWrap(sourceForm);
    var targetWrap = getPriceWrap(targetForm);
    if (sourceWrap && targetWrap) {
      ['min', 'max'].forEach(function (key) {
        var cls = key === 'min' ? '.field__input-min' : '.field__input-max';
        var sourceInput = sourceWrap.querySelector(cls);
        var targetInput = targetWrap.querySelector(cls);
        if (sourceInput && targetInput) targetInput.value = sourceInput.value;
      });

      var sourceRanges = sourceWrap.querySelectorAll('input[type="range"]');
      var targetRanges = targetWrap.querySelectorAll('input[type="range"]');
      if (sourceRanges.length >= 2 && targetRanges.length >= 2) {
        targetRanges[0].value = sourceRanges[0].value;
        targetRanges[1].value = sourceRanges[1].value;
      }

      var sourceTrack = sourceWrap.querySelector('.input-price-range');
      var targetTrack = targetWrap.querySelector('.input-price-range');
      if (sourceTrack && targetTrack) {
        if (sourceTrack.getAttribute('data-price-default') === 'true') {
          targetTrack.setAttribute('data-price-default', 'true');
        } else {
          targetTrack.removeAttribute('data-price-default');
        }
        updateRangeFill(targetTrack, targetRanges);
      }
    }
  }

  function syncActiveFormToMain(panel, sourceForm) {
    var mainForm = getMainForm(panel);
    var activeForm = sourceForm || getActiveForm(panel);
    if (!mainForm || !activeForm || mainForm === activeForm) return;
    syncFormToTarget(activeForm, mainForm);
  }

  function syncMainFormFromResponse(html, mainForm) {
    if (!html || !mainForm) return;
    var panel = mainForm.closest('#main-collection-filters');
    var sourceForm =
      html.querySelector('.group-type-list-wrapper .collection-filters_form') ||
      html.querySelector('#collection-filters-form');
    if (!sourceForm) return;
    syncFormToTarget(sourceForm, mainForm);
    if (panel) panel._preferredFilterForm = getJsForm(panel) || sourceForm;
  }

  function setPreferredForm(panel, form) {
    if (!panel || !form) return;
    panel._preferredFilterForm = form;
  }

  function triggerApply(panel) {
    var seq = ++applyCounter;

    syncActiveFormToMain(panel);

    var gridSection = panel.closest('.ubiquiti-product-grid');
    if (gridSection && gridSection._ubiquitiGridInstance) {
      gridSection._ubiquitiGridInstance.applyFilters();
      return;
    }

    panel.dispatchEvent(new CustomEvent('collection-filters:apply', { bubbles: true, detail: { seq: seq } }));
  }

  function handleRangeSliderInput(panel, target) {
    var parent = target.closest('.range-slider');
    if (!parent) return;

    var sourceForm = parent.closest('.collection-filters_form');
    setPreferredForm(panel, sourceForm);

    var minRange = parent.querySelector('.input-price-range__input--min');
    var maxRange = parent.querySelector('.input-price-range__input--max');
    var minNumber = parent.querySelector('.field__input-min');
    var maxNumber = parent.querySelector('.field__input-max');
    var track = parent.querySelector('.input-price-range');
    if (!minRange || !maxRange || !track) return;

    activatePriceRange(track);
    clearQuickRanges(parent);

    if (target === minRange) {
      var maxVal = parseFloat(maxRange.value);
      if (parseFloat(minRange.value) > maxVal) minRange.value = maxVal;
    } else if (target === maxRange) {
      var minVal = parseFloat(minRange.value);
      if (parseFloat(maxRange.value) < minVal) maxRange.value = minVal;
    }

    updateRangeFill(track, [minRange, maxRange]);
    if (minNumber) minNumber.value = minRange.value;
    if (maxNumber) maxNumber.value = maxRange.value;
    syncPriceWrapToMain(panel, parent);

    if (panel._debouncedPriceApply) panel._debouncedPriceApply();
  }

  function handlePriceNumberInput(panel, target) {
    var parent = target.closest('.range-slider');
    if (!parent) return;

    setPreferredForm(panel, parent.closest('.collection-filters_form'));

    var minRange = parent.querySelector('.input-price-range__input--min');
    var maxRange = parent.querySelector('.input-price-range__input--max');
    var minNumber = parent.querySelector('.field__input-min');
    var maxNumber = parent.querySelector('.field__input-max');
    var track = parent.querySelector('.input-price-range');
    if (!minRange || !maxRange || !minNumber || !maxNumber || !track) return;

    activatePriceRange(track);
    clearQuickRanges(parent);

    var floor = parseFloat(minRange.min) || 0;
    var ceiling = parseFloat(maxRange.max) || 0;
    var minVal = parseFloat(minNumber.value);
    var maxVal = parseFloat(maxNumber.value);
    if (isNaN(minVal)) minVal = floor;
    if (isNaN(maxVal)) maxVal = ceiling;
    if (minVal > maxVal) {
      if (target === minNumber) minVal = maxVal;
      else maxVal = minVal;
    }

    minRange.value = minVal;
    maxRange.value = maxVal;
    minNumber.value = minVal;
    maxNumber.value = maxVal;
    updateRangeFill(track, [minRange, maxRange]);
    syncPriceWrapToMain(panel, parent);
  }

  function resetPrice(panel) {
    [getMainForm(panel), getJsForm(panel)].forEach(function (form) {
      var wrap = getPriceWrap(form);
      if (!wrap) return;
      var min = wrap.querySelector('.field__input-min');
      var max = wrap.querySelector('.field__input-max');
      var ranges = wrap.querySelectorAll('input[type="range"]');
      var rangeMax = max ? max.getAttribute('max') : '';
      if (min) min.value = '';
      if (max) max.value = '';
      if (ranges.length >= 2) {
        ranges[0].value = 0;
        ranges[1].value = rangeMax;
      }
      clearQuickRanges(wrap);
      var trackEl = wrap.querySelector('.input-price-range');
      if (trackEl) trackEl.setAttribute('data-price-default', 'true');
      if (trackEl && ranges.length >= 2) updateRangeFill(trackEl, ranges);
    });
  }

  function clearAllFilters(panel) {
    var productSearch = panel.querySelector('.js-filter-product-search');
    if (productSearch) productSearch.value = '';

    [getMainForm(panel), getJsForm(panel)].forEach(function (form) {
      if (!form) return;
      form.querySelectorAll('.filter-group-display__list-item_checkbox:checked').forEach(function (cb) {
        cb.checked = false;
      });
    });

    resetPrice(panel);
    filterProductsByTitle(panel, '');
    triggerApply(panel);
  }

  function removeChip(panel, chip) {
    var type = chip.getAttribute('data-filter-type');

    if (type === 'list') {
      var name = chip.getAttribute('data-param-name');
      var value = chip.getAttribute('data-param-value');
      [getMainForm(panel), getJsForm(panel)].forEach(function (form) {
        if (!form) return;
        form.querySelectorAll('.filter-group-display__list-item_checkbox[name="' + name + '"]').forEach(function (cb) {
          if (cb.value === value) cb.checked = false;
          try {
            if (decodeURIComponent(cb.value) === value) cb.checked = false;
          } catch (e) {
            /* ignore */
          }
        });
      });
    }

    if (type === 'price') {
      resetPrice(panel);
    }

    triggerApply(panel);
  }

  function filterProductsByTitle(panel, query) {
    var template = panel.closest('.section-collection-template');
    if (!template) return;

    var grid = template.querySelector('#main-collection-product-grid');
    if (!grid) return;

    var normalized = (query || '').trim().toLowerCase();
    grid.querySelectorAll('product-card').forEach(function (card) {
      var titleEl = card.querySelector('.product-card_title');
      var title = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
      var match = !normalized || title.indexOf(normalized) !== -1;
      card.style.display = match ? '' : 'none';
    });
  }

  function setPriceOnPanel(panel, min, max) {
    var forms = [getMainForm(panel), getJsForm(panel)].filter(Boolean);
    var seen = [];

    forms.forEach(function (form) {
      if (seen.indexOf(form) !== -1) return;
      seen.push(form);

      var wrap = getPriceWrap(form);
      if (!wrap) return;

      var minInput = wrap.querySelector('.field__input-min');
      var maxInput = wrap.querySelector('.field__input-max');
      var ranges = wrap.querySelectorAll('input[type="range"]');
      var track = wrap.querySelector('.input-price-range');

      if (minInput) minInput.value = min;
      if (maxInput) maxInput.value = max;
      if (ranges.length >= 2) {
        ranges[0].value = min;
        ranges[1].value = max;
      }
      if (track) {
        track.removeAttribute('data-price-default');
        if (ranges.length >= 2) updateRangeFill(track, ranges);
      }
    });
  }

  function applyQuickRange(panel, radio) {
    setPriceOnPanel(panel, radio.getAttribute('data-min'), radio.getAttribute('data-max'));
    triggerApply(panel);
  }

  function updateActiveSummary(panel) {
    var chips = panel.querySelectorAll('.js-filter-active-chips .js-filter-chip');
    var count = chips.length;
    var label = panel.querySelector('.js-filter-active-label');
    var clearBtn = panel.querySelector('.js-filter-clear-all');
    var details = panel.querySelector('.js-filter-active-panel');

    if (clearBtn) clearBtn.hidden = count === 0;
    if (details && count > 0) details.open = true;
    if (details) details.hidden = count === 0;
    if (!label) return;

    var countTemplate = label.getAttribute('data-count-template');
    var emptyTemplate = label.getAttribute('data-empty-template');
    if (count > 0 && countTemplate) {
      label.textContent = countTemplate.replace('__COUNT__', String(count));
    } else if (emptyTemplate) {
      label.textContent = emptyTemplate;
    }
  }

  function refreshActiveChips(panel, html) {
    if (!html) return;
    var source = html.querySelector('.js-filter-active-chips');
    var target = panel.querySelector('.js-filter-active-chips');
    if (source && target) {
      target.innerHTML = source.innerHTML;
    }
    var sourceLabel = html.querySelector('.js-filter-active-label');
    var targetLabel = panel.querySelector('.js-filter-active-label');
    if (sourceLabel && targetLabel) {
      targetLabel.textContent = sourceLabel.textContent;
    }
    var sourceClear = html.querySelector('.js-filter-clear-all');
    var targetClear = panel.querySelector('.js-filter-clear-all');
    if (sourceClear && targetClear) {
      targetClear.hidden = sourceClear.hidden;
    }
    var sourcePanel = html.querySelector('.js-filter-active-panel');
    var targetPanel = panel.querySelector('.js-filter-active-panel');
    if (sourcePanel && targetPanel) {
      targetPanel.hidden = sourcePanel.hidden;
      if (!sourcePanel.hidden) {
        targetPanel.open = sourcePanel.open;
      }
    }
    updateActiveSummary(panel);
  }

  function bindPanelEvents(panel) {
    if (!panel || panel.dataset.filtersPanelBound === 'true') return;
    panel.dataset.filtersPanelBound = 'true';

    panel._debouncedPriceApply = debounce(function () {
      triggerApply(panel);
    }, DEBOUNCE_MS);

    var debouncedProductSearch = debounce(function (input) {
      filterProductsByTitle(panel, input.value);
    }, DEBOUNCE_MS);

    panel.addEventListener('click', function (event) {
      if (event.target.closest('.js-filter-clear-all')) {
        event.preventDefault();
        clearAllFilters(panel);
        return;
      }

      var chip = event.target.closest('.js-filter-chip');
      if (chip) {
        event.preventDefault();
        removeChip(panel, chip);
      }
    });

    panel.addEventListener('change', function (event) {
      if (event.target.matches('.filter-group-display__list-item_checkbox')) {
        setPreferredForm(panel, event.target.closest('.collection-filters_form'));
      }

      if (event.target.matches('.js-filter-price-quick')) {
        applyQuickRange(panel, event.target);
      }
    });

    panel.addEventListener('input', function (event) {
      if (event.target.matches('.input-price-range__input--min, .input-price-range__input--max')) {
        handleRangeSliderInput(panel, event.target);
        return;
      }

      if (event.target.matches('.field__input-min, .field__input-max')) {
        handlePriceNumberInput(panel, event.target);
        panel._debouncedPriceApply();
        return;
      }

      if (event.target.matches('.js-filter-product-search')) {
        debouncedProductSearch(event.target);
      }
    });
  }

  function getFilterTagGroupsConfig() {
    var el = document.getElementById('tpu-filter-tag-groups-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function applyFilterTagGroups(scope) {
    var config = getFilterTagGroupsConfig();
    if (!config || !config.enabled || !Array.isArray(config.groups) || !config.groups.length) return;

    var root = scope || document;
    var showMoreText = '+ Show more';
    var showLessText = '- Show less';
    var existingMore = root.querySelector('.maxlist-more') || document.querySelector('.maxlist-more');
    var existingLess = root.querySelector('.maxlist-less') || document.querySelector('.maxlist-less');
    if (existingMore) showMoreText = existingMore.textContent;
    if (existingLess) showLessText = existingLess.textContent;

    root.querySelectorAll('.js-filter-tag-groups-root').forEach(function (groupsRoot) {
      var form = groupsRoot.closest('form') || groupsRoot.parentElement;
      var pool = form && form.querySelector('.js-filter-tag-value-pool');
      if (!pool) return;

      var formId = groupsRoot.getAttribute('data-form-id') || 'collection-filters-form';
      var paramName = pool.getAttribute('data-param-name') || 'filter.p.tag';
      var inputs = Array.prototype.slice.call(pool.querySelectorAll('.js-filter-tag-pool-input'));
      var limit = 5;

      groupsRoot.innerHTML = '';

      config.groups.forEach(function (group) {
        var prefixKey = String(group.prefix || '')
          .trim()
          .replace(/:$/, '');
        var groupLabel = String(group.label || '').trim();
        if (!prefixKey || !groupLabel) return;

        var prefix = prefixKey + ':';
        var matched = inputs.filter(function (input) {
          var raw = input.getAttribute('data-label') || input.getAttribute('data-value') || '';
          var valuePrefix = raw.split(':')[0] + ':';
          return valuePrefix === prefix;
        });
        if (!matched.length) return;

        var details = document.createElement('details');
        details.className = 'filter-group js-filter-group filter-group--tag-prefix';
        details.open = true;
        details.setAttribute('data-param-name', paramName);
        details.setAttribute('data-tag-prefix', prefix);

        var summary = document.createElement('summary');
        summary.className = 'filter-group_title';
        summary.innerHTML =
          '<div class="filter-group_title_inner"><span></span><div class="filter-group_wrapper"></div></div>';
        summary.querySelector('span').textContent = groupLabel;
        details.appendChild(summary);

        var inner = document.createElement('div');
        inner.className = 'filter-group_inner';

        matched.forEach(function (poolInput, index) {
          var value = poolInput.getAttribute('data-value') || '';
          var rawLabel = poolInput.getAttribute('data-label') || value;
          var display = rawLabel.indexOf(prefix) === 0 ? rawLabel.slice(prefix.length) : rawLabel;
          var count = poolInput.getAttribute('data-count') || '0';
          var inputId = 'filter-tag-' + formId + '-' + prefixKey + '-' + (index + 1);

          var item = document.createElement('div');
          item.className = 'filter-group_item input-group' + (index + 1 > limit ? ' ind-hide' : '');
          item.setAttribute('data-filter-label', display);

          var checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.className = 'filter filter-group-display__list-item_checkbox';
          checkbox.name = poolInput.getAttribute('data-name') || paramName;
          checkbox.value = value;
          checkbox.id = inputId;
          checkbox.checked = !!poolInput.checked;

          var label = document.createElement('label');
          label.setAttribute('for', inputId);
          var textWrap = document.createElement('span');
          textWrap.className = 'no-js-hidden';
          textWrap.appendChild(document.createTextNode(display + ' ('));
          var countSpan = document.createElement('span');
          countSpan.className = 'js-count';
          countSpan.textContent = count;
          textWrap.appendChild(countSpan);
          textWrap.appendChild(document.createTextNode(')'));
          label.appendChild(textWrap);

          item.appendChild(checkbox);
          item.appendChild(label);
          inner.appendChild(item);
        });

        if (matched.length > limit) {
          var maxlist = document.createElement('div');
          maxlist.className = 'filter-maxlist';
          maxlist.innerHTML =
            '<span class="maxlist-more"></span><span class="maxlist-less d-none"></span>';
          maxlist.querySelector('.maxlist-more').textContent = showMoreText;
          maxlist.querySelector('.maxlist-less').textContent = showLessText;
          inner.appendChild(maxlist);
        }

        details.appendChild(inner);
        groupsRoot.appendChild(details);
      });
    });
  }

  function bindPanel(panel) {
    if (!panel) return;
    applyFilterTagGroups(panel);
    bindPanelEvents(panel);
    initRangeFills(panel);
    bindPriceRangeTracks(panel, panel);
    updateActiveSummary(panel);
  }

  function init(scope) {
    var root = scope || document;
    applyFilterTagGroups(root);
    root.querySelectorAll('#main-collection-filters').forEach(bindPanel);
    initRangeFills(root);
  }

  window.CollectionFiltersEnhancements = {
    init: init,
    applyFilterTagGroups: applyFilterTagGroups,
    refreshActiveChips: refreshActiveChips,
    initRangeFills: initRangeFills,
    bindPriceRangeTracks: bindPriceRangeTracks,
    syncActiveFormToMain: syncActiveFormToMain,
    syncMainFormFromResponse: syncMainFormFromResponse,
    setPreferredForm: setPreferredForm,
    getActiveForm: getActiveForm,
    getMainForm: getMainForm,
    getFilterQuery: getFilterQuery
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
